import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate  } from "react-router-dom";
import Cookies from "js-cookie";
import MiniDrawer from "./components/Menubar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchPdfEditorDetails } from "./store/reducers/pdfEditorTokenSlice";
import { checkActiveLogin } from "./store/reducers/activeLoginSlice";

const ProtectedLayout = () => {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [open, setOpen] = useState(true);
  const [openSideBar, setOpenSideBar] = useState(true);
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profile);

  const { is_active, status } = useSelector((state) => state.activeLogin);

  useEffect(() => {
    if (!is_active && !status) {
      dispatch(checkActiveLogin());
    }
  }, [dispatch, is_active, status]);

  useEffect(() => {
    if (status === "succeeded") {
      if (!is_active) {
        navigate("/login");
      } else {
        sessionStorage.setItem("token", "success");
      } 
    }
  }, [is_active, status, navigate]);


  useEffect(() => {
    if (profileData?.status === true && profileData.username && token) {
      dispatch(fetchPdfEditorDetails(profileData.username));
    }
  }, [profileData.status, profileData.username, token, dispatch]);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return (
    <>
      <MiniDrawer open={open} setOpen={setOpen} setOpenSideBar={setOpenSideBar} openSideBar={openSideBar} />

      <Outlet context={{ open, setOpen, openSideBar, setOpenSideBar }} />
    </>
  );
};

export default ProtectedLayout;
